<template>
  <div class="pavList">
    <div class="item" :key="index" v-for="(item, index) in dataList">
      <div class="cover" @click="gourl(item.url)">
        <img :src="item.cover" alt="" width="100%" />
      </div>
      <div class="name">{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: "",
    };
  },
  created() {
    this.$axios.get("/book/wxlist").then((res) => {
      this.dataList = res.data;
    });
  },
  methods: {
    gourl(url) {
      window.location.href = url;
    },
  },
};
</script>
<style scoped lang="less">
.pavList {
  width: 100%;
  padding: 0.2rem;
  box-sizing: border-box;
  .item {
    width: 100%;
    margin-bottom: 0.2rem;
    .cover {
      margin-bottom: 0.1rem;
      img{
        border-radius: 0.1rem;
      }
    }
    .name {
      width: 100%;
      text-align: center;
    }
  }
}
</style>